import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { FoodCostCalculatorService } from './food-cost-calculator.service';

@Injectable({
  providedIn: 'root',
})
export class FoodCostCalculatorResolverService {
  constructor(private foodCostCalculatorService: FoodCostCalculatorService) {}

  resolve(route: ActivatedRouteSnapshot, state?: RouterStateSnapshot): void {
    this.foodCostCalculatorService.resetFoodCostReportsState();
    this.foodCostCalculatorService.loadFoodCostReports();
  }
}
